import { Component, inject, Input, OnInit } from '@angular/core';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import { ModeControlMultipleComponent } from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { ModeControlSimpleComponent } from '../../../../../../../../components/ecosystems/mode-control-simple/mode-control-simple.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SelectTimerControlComponent } from '../../../../../../../../components/ecosystems/select-timer-control/select-timer-control.component';
import { getColorDescriptor } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { P00039WelticoV2ColorChoiceComponent } from '../../../../P00039/Eclairage/components/p00039-weltico-v2-color-choice/p00039-weltico-v2-color-choice.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import convertSecondsToTime from '../../../../../../helper/convertSecondsToTime';
import { P0003600EnSavoirPlusComponent } from '../../enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';

@Component({
  selector: 'app-p0003600-filtration-controle',
  templateUrl: './p0003600-filtration-controle.component.html',
  styleUrls: ['./p0003600-filtration-controle.component.scss'],
  imports: [
    IonLabel,
    ModeControlMultipleComponent,
    ModeControlSimpleComponent,
    TranslatePipe,
  ],
})
export class P0003600FiltrationControleComponent implements OnInit {
  private slideModalcontroller: SlideModalController =
    inject(SlideModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async openenSavoirPlus() {
    const modal = await this.slideModalcontroller.create({
      component: P0003600EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly convertSecondsToTime = convertSecondsToTime;
}
